<template>
  <nav
    class="AiSkiplinks-nav Layout"
    :aria-label="$t('accessibility.skiplinks.description')"
    role="navigation">
    <ul>
      <li>
        <ai-skiplinks-item
          :label="$t('accessibility.skiplinks.label.content')"
          anchor="#main-content"
          :inverse="inverse" />
      </li>
      <li>
        <ai-skiplinks-item
          :label="$t('accessibility.skiplinks.label.bookingBar')"
          anchor="#AiBookingBar"
          :inverse="inverse" />
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
type Props = {
  inverse?: boolean;
};
withDefaults(defineProps<Props>(), {
  inverse: false,
});
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';

.AiSkiplinks-nav {
  align-items: center;
  position: absolute;
  opacity: 0;
  inset-inline: 0;
  height: calc(constants.$inner-06 * 1.5);

  ul {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-block: constants.$padding-01;
    gap: constants.$margin-01;

    @media (mq.$from-medium) {
      padding: 0;
    }
  }

  &:focus-within {
    opacity: 1;
  }
}
</style>
